import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container } from 'reactstrap'

const AsburyIcon: string = require("../../../../assets/images/company/Asbury.svg").default;
const AutonationIcon: string = require("../../../../assets/images/company/Autonation.svg").default;
const BerkshireHathawayIcon: string = require("../../../../assets/images/company/BerkshireHathaway.svg").default;
const FindlayIcon: string = require("../../../../assets/images/company/Findlay.svg").default;
const FletcherJonesIcon: string = require("../../../../assets/images/company/FletcherJones.svg").default;
const LarryHMillierIcon: string = require("../../../../assets/images/company/LarryHMiller.svg").default;
const PenskeIcon: string = require("../../../../assets/images/company/Penske.svg").default;

let settings = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1500,
  slidesToShow: 6,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 2
      }
    },
  ]
};

function PartnersCarousel() {
  return (<section className="section py-5 partners-carousel-section">
    <div className="text-center mb-5">
      <div className="small-title text-primary">Our partners</div>
      <h4 className="text-secondary">Trusted by the nation's largest dealership</h4>
    </div>
    <Container className='partners-carousel px-5'>
        <Slider {...settings}>
          <img src={AutonationIcon} alt='autonation' className='mt-2'/>
          <img src={LarryHMillierIcon} alt="Larry H Miller" />
          <img src={BerkshireHathawayIcon} alt="Berkshire Hathaway" className='mt-3'/>
          <img src={FletcherJonesIcon} alt="Fletcher Jones" className='mt-3'/>
          <img src={FindlayIcon} alt="Findlay" className='mt-1'/>
          <img src={PenskeIcon} alt="Penske" />
          <img src={AsburyIcon} alt="Asbury" className='mt-1'/>
        </Slider>
    </Container>
  </section>
)}

export default PartnersCarousel
